import axios from 'axios'
import { GET_USER_BY_EMAIL, GET_USERS_ERRORS } from './types'
import { setAuthLoading } from './authActions'
import { ToastsStore } from 'react-toasts'

export const resendVerifyEmail = ({ email, history }) => dispatch => {  
  axios
    .post(`/api/users/resend_email/${email}`)
    .then(() => {
      ToastsStore.success('Email has been sent')
      history.push('/login')
    })
    .catch(err => ToastsStore.success('Email did not send. Please try again'))
}
